import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/pages/Home';

import Discography from './components/pages/Discography';
import Biography from './components/pages/Biography';
import Store from './components/pages/Store';
import Contact from './components/pages/Contact';
import Shows from './components/pages/Shows';
import EPK from './components/pages/EPK';

import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Popup from 'reactjs-popup';

function App() {
  return (
    <>

      <Router>

        <Routes>
          <Route path='/' element={<Home/>} />
          <Route path='/discography' element={<Discography/>} />
          <Route path='/biography' element={<Biography/>} />
          <Route path='/store' element={<Store/>} />
          <Route path='/shows' element={<Shows/>} />
          <Route path='/contact' element={<Contact/>} />
          <Route path="/EPK" element={<EPK />} />


        </Routes>
      </Router>
    </>
  );
}

export default App;
